import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Wrapper, LinkWrapper } from '../css_global/utils.css';
import PageHeading from '../components/PageHeading/PageHeading';

const mapStateToProps = ({ api: { s3BasePath } }) => ({
  s3BasePath,
});

class CharitableGiving extends React.Component {
  render() {
    return (
      <Wrapper>
        <PageHeading text="CHARITABLE GIVING" />
        <Wrapper textAlign="center" margin="0 21px">
          <Wrapper height="30px" />
          <Wrapper fontSize="15px" fontWeight="900" font={'"Avenir Black", "Arial Black", sans-serif'} uppercase>
            Investing in the Future
          </Wrapper>
          <Wrapper height="10px" />
          <Wrapper lineHeight="18px">
            italist combined technology and luxury to become the first platform for direct-to-consumer luxury imports
            exclusively from Italy. As a company, we value innovation and believe in supporting the next generation of
            creative thinkers.
            <br />
            <br />
            How can we prepare today’s minds to be tomorrow’s innovators? We believe an excellent education is the first
            step to building a foundation for young minds to discover their creative potential. That’s why italist is
            donating a percentage of sales to support schools through our Charitable Giving initiative.
          </Wrapper>
          <Wrapper height="40px" />
          <Wrapper fontSize="15px" fontWeight="900" font={'"Avenir Black", "Arial Black", sans-serif'} uppercase>
            Our giving model
          </Wrapper>
          <Wrapper height="10px" />
          <Wrapper lineHeight="18px">
            Our current nonprofit partner in this initiative is <b>Beverly Hills Education Foundation</b>. italist will
            donate 5% of sales from registered donors to support BHEF and fund academic courses and extracurricular
            programs ranging from technology and digital media to arts and sciences. By investing in education and
            empowering students to be innovative thinkers, we all benefit—our kids, our community, and our city.
          </Wrapper>
          <Wrapper height="40px" />
          <Wrapper fontSize="15px" fontWeight="900" font={'"Avenir Black", "Arial Black", sans-serif'} uppercase>
            Beverly Hills Education Foundation
          </Wrapper>
          <Wrapper height="20px" />
          <Wrapper>
            <img src={`${this.props.s3BasePath}charity/bhef_logo.png`} />
          </Wrapper>
          <Wrapper height="20px" />
          <Wrapper lineHeight="18px">
            The Beverly Hills Education Foundation believes that nothing is more important than the education of our
            children. Our goal is to have schools that are rich in programming, academic challenges, and enrichment
            opportunities. We want our students to develop critical thinking skills as well as the character required to
            use these skills in ways that allow them to meet the challenges unique to their generation.
          </Wrapper>
          <Wrapper height="20px" />
          <a href="https://www.bhef.org/">
            <LinkWrapper>GO TO BHEF TO LEARN MORE</LinkWrapper>
          </a>
          <Wrapper height="90px" />
        </Wrapper>
      </Wrapper>
    );
  }
}

CharitableGiving.propTypes = {
  s3BasePath: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(CharitableGiving);
